export const GET_USER_SURVEYS_SUCCESS = "GET_USER_SURVEYS_SUCCESS";
export const GET_USER_SURVEYS_FAILURE = "GET_USER_SURVEYS_FAILURE";

export const GET_SINGLE_SURVEY_SUCCESS = "GET_SINGLE_SURVEY_SUCCESS";
export const GET_SINGLE_SURVEY_FAILURE = "GET_SINGLE_SURVEY_FAILURE";

export const SUBMIT_SURVEY_RESPONSE_SUCCESS = "SUBMIT_SURVEY_RESPONSE_SUCCESS";
export const SUBMIT_SURVEY_RESPONSE_FAILURE = "SUBMIT_SURVEY_RESPONSE_FAILURE";
